






























import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { alertStore, appStore, modalErrorStore } from '@/store'
import {
  AlertMessage,
  defaultSystemCodeArea,
  ErrorMessage,
  SystemCodeArea,
  systemCodeAreaApi
} from '@/api'

@Component
export default class AtomSystemCodeAreaSelect extends ComponentVue {
  @Prop({ type: String })
  label!: string

  @Prop({ type: Object })
  value!: SystemCodeArea

  @Prop({ type: Boolean, default: false })
  displayName!: boolean

  @Prop({ type: Boolean, default: false })
  error!: boolean

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({ type: Number, default: 500 })
  emitIntervalMs!: number

  @Prop({ type: Boolean, default: false })
  blank!: boolean

  items: SystemCodeArea[] = []

  isEmit: boolean = true

  get useItems(): SystemCodeArea[] {
    return this.blank ? [defaultSystemCodeArea(), ...this.items] : this.items
  }

  get fontSize(): number {
    return appStore._fontSizeNormal
  }

  get style(): object {
    return {
      'font-size': this.fontSize + 'px'
    }
  }

  get isError(): boolean {
    return this.error || this.errorMessage !== ''
  }

  created() {
    this.fetchAreaCode()
  }

  @Emit('input')
  onChange() {}

  onKeydownEnter() {
    if (this.isEmit) {
      this.$emit('keydown:enter')
      this.isEmit = false

      setTimeout(() => (this.isEmit = true), this.emitIntervalMs)
    }
  }

  itemText(item: SystemCodeArea) {
    return (
      item.code +
      (item.code ? '：' : '') +
      (this.displayName ? item.name : item.shortName)
    )
  }

  itemValue(item: SystemCodeArea) {
    return item
  }

  async fetchAreaCode() {
    try {
      this.items = await systemCodeAreaApi.getAllSystemCodeArea()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }
}
